import { gql } from "@apollo/client"

export const GET_MY_ORGANIZATION_PENDING_INVITATIONS = gql`
  query getMyOrganizationPendingInvitations {
    myOrganization {
      id
      name
      pendingInvitations {
        id
        toUser
        organization {
          id
          name
        }
        initialGroup {
          id
          name
          organizationGroup {
            id
            name
          }
        }
      }
    }
  }
`
